import { Flex } from "antd";
import SearchInput from "pages/media/projects/components/SearchInput";
import { QuickFilters, QuickFiltersProps } from "./QuickFilters";
import {
  TableFieldsDropdown,
  TableFieldsDropdownProps,
} from "./TableFieldsDropdown";

// Shared toolbar for tables that need quick-filter pills + a search box + a
// "which columns are visible" dropdown (Experiences and Projects tables).
// Layout only — each child's own props are passed straight through instead
// of being flattened/renamed here, so this stays a thin composition.

export type TableFiltersProps<K extends string = string> = {
  quickFilters: QuickFiltersProps;
  fieldsDropdown: TableFieldsDropdownProps<K>;
  searchValue: string;
  onSearchChange: (value: string) => void;
  searchPlaceholder: string;
};

export const TableFilters = <K extends string = string>({
  quickFilters,
  fieldsDropdown,
  searchValue,
  onSearchChange,
  searchPlaceholder,
}: TableFiltersProps<K>) => {
  return (
    <Flex
      justify="space-between"
      align="center"
      gap={8}
      wrap="wrap"
      style={{ padding: "16px 25px" }}
    >
      <QuickFilters {...quickFilters} />
      <Flex
        style={{ flex: "1 1 40%" }}
        align="center"
        justify="end"
        wrap="wrap"
        gap={8}
      >
        <div>
          <SearchInput
            onSearch={onSearchChange}
            value={searchValue}
            size="large"
            name={searchPlaceholder}
          />
        </div>
        <TableFieldsDropdown {...fieldsDropdown} />
      </Flex>
    </Flex>
  );
};
